import styled from "styled-components"
import media from "src/styles/media"

export const AboutSliderWrapper = styled.section`
    position: relative;
    height: auto;
    width: 100%;
    z-index: 5;
    margin-top: 10px;
    margin-bottom: -320px;
   
   ${media.greaterThan("lg")`
        padding: 0 40px;
   `}

    .slick-slide{
        > div{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 500px;
            padding: 0 15px;

            ${media.lessThan("md")`
                height: 410px;
            `}
        }
    }
    
    .slick-dots{

        li{
            width: 11px;
            height: 11px;
            transition: width 0.4s;

            @media screen and (max-width: 768px){
                width: 18px;
                height: 18px;
                margin: 0px 6px;
                margin-top: 5px;
            }
        }

        button{
            margin-top: -10px;
            display: block;
            width: 100%;
            height: 100%;
            background-color: #aaa7e6;
            border-radius: 50%;
            transition: background-color 0.4s;

            &:before{
                display: none;
            }


        }

        .slick-active{
            width: 44px;

            button{
                background-color: var(--dark);
                border-radius: 5px;
            }
        }
    }

    ${media.lessThan("lg")`
        margin-bottom: -240px;
    `}

    ${media.lessThan("md")`
        margin-bottom: -180px;
    `}

    ${media.lessThan("sm")`
        margin-bottom: -150px;
    `}

    @media screen and (min-width: 1600px){
        margin-bottom: -19vw;
    }
`
export const AboutSliderItem = styled.article`
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  background-color: #fff;
  box-shadow: 3px 4px 10px rgba(0, 0, 0, 0.2);
  color: var(--dark);
  border-radius: 15px;
  transition: all 0.3s ease-in-out;
  padding: 10px 25px 10px 30px;
  width: 100%;
  height: 340px;
  max-width: 400px;

  ${media.lessThan("md")`
        height: 390px !important;
    `}

  ${media.lessThan("sm")`
        height: 360px !important;
        max-width: 270px !important;
    `}
        
    &:focus {
    outline: none;
  }

  &:hover {
    transform: scale(1.04);
    cursor: pointer;
  }

  .slick-slide.slick-center & {
    height: 420px;
    width: 99% !important;
  }
`

export const AboutSliderItemIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  width: 60px;
  height: 60px;
  border: 2px solid var(--dark);
  border-radius: 50%;
  margin-left: -5px;
  margin-bottom: 5px;

  svg {
    width: 50%;
  }

  ${media.lessThan("sm")`
        width: 60px;
        height: 60px;
        margin-bottom: 4px;
    `}
`

export const AboutSliderItemTitle = styled.h1`
  font-size: 28px;
  font-weight: 400;
  margin-bottom: 5px;

  ${media.lessThan("sm")`
        font-size: 25px;
    `}
`

export const AboutSliderItemDesc = styled.p`
  font-size: 18px;
  line-height: 1.2;
  margin-bottom: 0;
  font-weight: 300;

  ${media.lessThan("sm")`
        font-size: 16px;
    `}
`

export const AboutSliderItemNext = styled.button`
  position: relative;
  display: block;
  background: none;
  border: 2px solid var(--dark);
  height: 0;
  width: 0;
  opacity: 0;
  border-radius: 50%;
  margin-top: 20px;
  transition: background-color 0.4s;
  overflow: hidden;

  .slick-center & {
    animation: fadeInLeft 0.8s;
    height: 40px;
    width: 40px;
    opacity: 1;

    ${media.lessThan("sm")`
            height: 35px;
            width: 35px;
        `}
  }

  ${media.lessThan("sm")`
        height: 35px;
        width: 35px;
        opacity: 1 !important;
    `}

  &:hover {
    background-color: var(--dark);
    color: #fff;
  }

  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 47px;
    transition: color 0.4s;

    ${media.lessThan("sm")`
            width: 34px;
        `}
  }
`
